<div class="fantasy-panel rounded shadow overflow-hidden">
  <div class="row mx-0">
    <div class="bg-primary game-panel-details text-white" [ngClass]="{ 'col-lg-7  ': horizontal }">
      <ng-container *ifScreenSize="screenType.Desktop">
        <div class="text-center time-to-play">
          <div class="font-size-12">{{ 'pick.player.time.left' | translate }}</div>
          <fgbcl-countdown class="font-size-14 fw-bold" [endDateTime]="game.EndDate"></fgbcl-countdown>
        </div>
        <div class="team-vs-team">
          <div class="team home col-4">
            <img
              *ngIf="game.HomeTeamLogo"
              class="d-flex ms-auto me-auto mt-3 mt-lg-0"
              src="{{ game.HomeTeamLogo | contentImage : '7' }}"
            />
          </div>
          <div class="versus col-4 text-center">
            <div class="svg svg-white vs-svg ms-auto me-auto" [inlineSVG]="'assets/images/icons/vs.svg'"></div>
          </div>
          <div class="team away col-4">
            <img
              *ngIf="game.AwayTeamLogo"
              class="d-flex ms-auto me-auto mt-3 mt-lg-0"
              src="{{ game.AwayTeamLogo | contentImage : '7' }}"
            />
          </div>
        </div>
        <div class="font-size-12 text-center">
          <div class="date">{{ gameDate }}, {{ gameTime }}</div>
        </div>
      </ng-container>
      <ng-container *ifScreenSize="screenType.Mobile">
        <div class="time-to-play">
          <div class="font-size-12">{{ 'pick.player.time.left' | translate }}</div>
          <fgbcl-countdown class="font-size-16 fw-bold" [endDateTime]="game.EndDate"></fgbcl-countdown>
        </div>

        <div class="team-vs-team mx-0">
          <div class="team home">
            <img *ngIf="game.HomeTeamLogo" class="d-flex mx-auto" src="{{ game.HomeTeamLogo | contentImage : '7' }}" />
          </div>

          <div class="game-dates-group">
            <div class="versus text-center">
              <div class="svg svg-white vs-svg ms-auto me-auto" [inlineSVG]="'assets/images/icons/vs.svg'"></div>
            </div>

            <div class="font-size-12 text-center">
              <div class="date">{{ gameDate }}, {{ gameTime }}</div>
            </div>
          </div>
          <div class="team away">
            <img *ngIf="game.AwayTeamLogo" class="d-flex mx-auto" src="{{ game.AwayTeamLogo | contentImage : '7' }}" />
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-12 bg-tertiary select-panel-details" [ngClass]="{ 'col-lg-5': horizontal }">
      <div class="d-none d-lg-block">
        <div class="player-select text-center">
          <div class="player-image mx-auto rounded-circle overflow-hidden" [ngClass]="{ border: !selectedPlayer }">
            <img
              *ngIf="selectedPlayer && selectedPlayer.Image"
              src="{{ selectedPlayer.Image | contentImage : '7' }}"
              class="w-100 h-100 m-auto"
            />
          </div>

          <fgb-fantasy-player-select-confirm
            [isGamePending]="isGamePending"
            [game]="game"
            [buttonState]="buttonState"
            [selectedPlayer]="selectedPlayer"
            (button)="buttonClick()"
          >
          </fgb-fantasy-player-select-confirm>
        </div>
      </div>
      <ng-container *ifScreenSize="screenType.Mobile">
        <div class="player-select d-flex">
          <div class="player-image rounded-circle overflow-hidden" [ngClass]="{ border: !selectedPlayer }">
            <img
              *ngIf="selectedPlayer && selectedPlayer.Image"
              src="{{ selectedPlayer.Image | contentImage : '7' }}"
              class="w-100 h-100 m-auto"
            />
          </div>
        </div>
        <div class="text-center">
          <fgb-fantasy-player-select-confirm
            [isGamePending]="isGamePending"
            [game]="game"
            [buttonState]="buttonState"
            [selectedPlayer]="selectedPlayer"
            (button)="buttonClick()"
          >
          </fgb-fantasy-player-select-confirm>
        </div>
      </ng-container>
    </div>
  </div>
</div>
